import { useRef } from 'react'

// Combine refs
export function useCombinedRef<T extends HTMLElement>(
  ref: React.ForwardedRef<T>
): [React.MutableRefObject<T | null>, (node: T | null) => void] {
  const internalRef = useRef<T | null>(null)
  
  const combinedRef = (node: T | null) => {
    if (typeof ref === 'function') {
      ref(node)
    } else if (ref && 'current' in ref) {
      (ref as React.MutableRefObject<T | null>).current = node
    }
    if (node && 'current' in internalRef) {
      internalRef.current = node
    }
  }
  
  return [internalRef, combinedRef]
}
